define('presentation/settings/integrations/viewModels/addIntegrationViewModel',[
    'i18next',
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'presentation/settings/integrations/facades/addIntegrationFacade',
    'settings/navigationConfiguration'
], function(){
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _i18n = require('i18next');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _router = require('businessServices/router/router');

        let _facade = null;

        const _addIntegrationAccessToken = () => {
            return _promiseFactory.defer((promise) => {
                _facade.addIntegrationAccessToken(self.integration(), self.authorizationCode(),
                    `${window.location.origin}${window.location.pathname}`)
                    .done(() => {
                        promise.resolve();
                    })
                    .fail(promise.reject);
            });
        };

        self.isCompositionComplete = ko.observable(false);

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.integration = ko.observable(null);
        self.authorizationCode = ko.observable(null);

        self.integrationName = ko.pureComputed(() => {
            return _i18n.t("integrations:integrationName", { context: self.integration() });
        });

        self.integrationIconCss = ko.pureComputed(() => {
           return `add-integration__icon--${self.integration()}`;
        });

        self.integrationStatusTitle = ko.pureComputed(() => {
            if (self.authorizationCode()) {
                return _i18n.t("addIntegration:confirmationMessageTitle", { context: self.integration() });
            }
            return _i18n.t("addIntegration:failureMessageTitle", { context: self.integration() });
        });

        self.integrationStatusMessage = ko.pureComputed(() => {
            if (self.authorizationCode()) {
                return _i18n.t("addIntegration:confirmationMessageBody", { context: self.integration() });
            }
            return _i18n.t("addIntegration:failureMessageBody", { context: self.integration() });
        });

        self.navigateBackToIntegrations = () => {
            const url = _navigationConfiguration.routesById.integrations.url;
            _router.navigate(url);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/integrations/facades/addIntegrationFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            return _initialize();
        };

        const _initialize = () => {
            const [integration] = _router.activeInstruction().params;
            self.integration(integration);

            const queryParams = _router.activeInstruction().queryParams;
            if (queryParams && queryParams["code"]) {
                self.authorizationCode(queryParams["code"]);
                _addIntegrationAccessToken();
            }

            return _promiseFactory.wait();
        };
    };
});

